'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styled = _interopDefault(require('styled-components'));
var Divider = _interopDefault(require('@narvar/nth-divider'));

var StyledButtonCardDivider = styled(Divider).withConfig({
  componentId: "nz9klo-0"
})(["margin:", ";line-height:", ";"], function (props) {
  return props.s.margin || '1rem auto';
}, function (props) {
  return props.s.lineHeight || '1rem';
});
var HorizontalDivider = function HorizontalDivider(props) {
  return /*#__PURE__*/React__default.createElement(StyledButtonCardDivider, props);
};
HorizontalDivider.defaultProps = {
  s: {}
};
HorizontalDivider.displayName = 'Divider';

exports.default = HorizontalDivider;
